import * as React from 'react';

import './icon-styles.css';

export interface IRectangleIconProps {
    fillColor?: string;
    strokeColor?: string;
}

export const RectangleIcon = (props: IRectangleIconProps) => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <rect
                className="icon-soft-stroke"
                x="7"
                y="8"
                width="18"
                height="16"
            />
            <rect
                className="icon-style"
                style={{fill: props.fillColor, stroke: props.strokeColor}}
                x="7"
                y="8"
                width="18"
                height="16"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-rectangle.tsx